export default "__VITE_ASSET___9QUlzsl__"